import React from 'react';
import { Text } from '@chatsdet/ui';
import { CopyButton } from '../../ui/components/CopyButton';
import {
  FIRST_RUN_COMMANDS,
  FIRST_RUN_COMMANDS_LABEL,
  FIRST_RUN_INTRO,
  FIRST_RUN_OUTRO,
  FIRST_RUN_PROMPT,
  FIRST_RUN_PROMPT_LABEL,
} from './firstRunCopy';

function CopyLine({ value }: { value: string }) {
  return (
    <div className="group/json relative rounded-md border border-border bg-muted px-3 py-2 pr-10 font-mono text-xs text-foreground">
      {value}
      <CopyButton value={value} variant="surface" />
    </div>
  );
}

/** Shown in place of the empty-thread hint when the org has no applications or tests yet. */
export function FirstRunWelcome() {
  return (
    <div className="flex flex-col gap-3 p-4 text-sm" data-testid="first-run-welcome">
      <Text className="text-foreground">{FIRST_RUN_INTRO}</Text>
      <Text className="text-muted-foreground">{FIRST_RUN_COMMANDS_LABEL}</Text>
      <div className="flex flex-col gap-2">
        {FIRST_RUN_COMMANDS.map((command) => (
          <CopyLine key={command} value={command} />
        ))}
      </div>
      <Text className="text-muted-foreground">{FIRST_RUN_PROMPT_LABEL}</Text>
      <CopyLine value={FIRST_RUN_PROMPT} />
      <Text className="text-muted-foreground">{FIRST_RUN_OUTRO}</Text>
    </div>
  );
}
